import { useCallback, useRef, useState } from 'react';

/**
 * State with a ref that always holds the same value. Work that runs after a render, such as
 * a save resolving or an editor flushing on unmount, reads the ref and sees the latest value
 * without waiting for React to render it.
 */
export function useStateRef<T>(initial: T): [T, React.RefObject<T>, (next: T) => void] {
  const [value, setValue] = useState(initial);
  const ref = useRef(initial);
  const write = useCallback((next: T) => {
    ref.current = next;
    setValue(next);
  }, []);
  return [value, ref, write];
}
